module.exports = __webpack_public_path__ + "img/agent.f89ed775.svg";